<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title *ngIf="isNewItem==false">{{'items.NewItem.update' | translate}}</h2>
    <h2 mat-dialog-title *ngIf="isNewItem==true">{{'items.NewItem.create' | translate}} {{testId}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button (click)="closeDialog()" mat-icon-button mat-dialog-close aria-label="Close Dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-dialog-content class="mat-typography">
    <form [formGroup]="basicDetailsForm" novalidate>
      <div class="form-wrapper">
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'items.NewItem.inputName' | translate}}</label><span class="required">*</span>
          </div>
          <div class="input-field">
            <input type="text" rows="1" maxlength="121" class="form-control" formControlName="itemTitle"
               [readonly]='isPublished'>
            <!-- <textarea type="text" rows="2" maxlength="121" class="form-control textarea" formControlName="itemTitle" *ngIf="isNewItem==true"
                [(ngModel)]="itemBankName"></textarea> -->
            <div *ngIf="f.itemTitle.invalid && (f.itemTitle.dirty || f.itemTitle.touched) && !f.itemTitle.errors?.whitespace" class="alert alert-danger">
              <div *ngIf="f.itemTitle.errors?.required">{{'items.NewItem.nameError1' | translate}}</div>
              <div *ngIf="f.itemTitle.errors?.minlength">{{'items.NewItem.nameError2' | translate}}</div>
              <div *ngIf="f.itemTitle.errors?.maxlength">{{'items.NewItem.nameError3' | translate}}</div>
              <div *ngIf="f.itemTitle.errors?.pattern">{{'items.NewItem.nameError4' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'items.NewItem.inputDesc' | translate}}</label>
          </div>
          <div class="input-field">
            <textarea type="text" rows="8" maxlength="481" class="form-control textarea" formControlName="itemDes"

              [readonly]='isPublished'></textarea>
            <!-- <textarea type="text" rows="8" maxlength="481" class="form-control textarea" formControlName="itemDes"
              *ngIf="isNewItem==true" [(ngModel)]="itemDescription"></textarea> -->
            <div *ngIf="f.itemDes.invalid && (f.itemDes.dirty || f.itemDes.touched)" class="alert alert-danger">
              <div *ngIf="f.itemDes.errors?.minlength">{{'items.NewItem.descError1' | translate}}</div>
              <div *ngIf="f.itemDes.errors?.maxlength">{{'items.NewItem.descError2' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="input-wrapper">
          <div class="input-label">
            <label>{{'items.NewItem.scoringType' | translate}}<span class="required">*</span></label>
          </div>
          <div class="input-field">
            <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" formControlName="scoringTypeId" [(ngModel)]="selectedScoringType"
              (change)="changeScoringType(selectedScoringType)" [attr.disabled]="isStyleGroupDisabed">
              <option *ngFor="let option of scoringTypes" [value]="option?.scoringTypeId" >
                {{option?.scoringTypeName}}
              </option>
            </select>
          </div>
        </div>

        <div class="input-wrapper" *ngIf="isStyleGroupShow">
          <div class="input-label">
            <label>{{'items.NewItem.styleGroup' | translate}}<span class="required">*</span></label>
          </div>
          <div class="input-field">
            <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid" [attr.disabled]="isStyleGroupDisabed"
              ng-reflect-model="" formControlName="styleGroupId" [(ngModel)]="selectedstyleGroup">
              <option *ngFor="let option of styleGroupData" [value]="option?.styleGroupId">
                {{option?.styleGroupName}}
              </option>
            </select>
          </div>
          <div *ngIf="f.styleGroupId.invalid && (f.styleGroupId.touched)">
            <div class="alert alert-danger" *ngIf="f.styleGroupId.errors?.required">{{'items.NewItem.styleGroupError1' | translate}} </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <!-- <button mat-flat-button color="" (click)='saveBasicItemDetails()'  mat-raised-button class="btn-bg-color"
    [disabled]='basicDetailsForm.invalid || isPublished'>Save</button> -->
    <button mat-flat-button color="" (click)='saveBasicItemDetails()' mat-raised-button class="btn-primary"
      [disabled]='(f.itemTitle.invalid || f.itemDes.invalid || f.scoringTypeId.invalid || f.styleGroupId.invalid)'>{{'items.NewItem.btnSave' | translate}}</button>
  </mat-dialog-actions>
</div>
